import { render, staticRenderFns } from "./UtochExpenses.vue?vue&type=template&id=735747ab&scoped=true&"
import script from "./UtochExpenses.vue?vue&type=script&lang=ts&"
export * from "./UtochExpenses.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735747ab",
  null
  
)

export default component.exports